import {RatingHeaderDetailsProps} from '../../types';

export const getRatingRange = (details: RatingHeaderDetailsProps) => {
  const data: number[] = [];

  for (let i = details.min; i <= details.max; i += details.step) {
    data.push(i);
  }

  return data;
};
